import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea0cfcc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "finish-machine-modal card" }
const _hoisted_3 = {
  id: "finish-machine-title",
  class: "finish-machine-title"
}
const _hoisted_4 = { class: "finish-machine-message" }
const _hoisted_5 = { class: "finish-machine-actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}

import { computed, onBeforeUnmount, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: Boolean },
    title: null,
    message: null,
    finishLabel: null,
    continueLabel: null,
    loading: { type: Boolean, default: false },
    closeOnOverlay: { type: Boolean, default: true }
  },
  emits: ["finish", "continue-using", "close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'finish'): void;
	(e: 'continue-using'): void;
	(e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { show: boolean, title?: string, message?: string, finishLabel?: string, continueLabel?: string, loading: boolean, closeOnOverlay: boolean }

const { t } = useI18n();
const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage') || 'en');



const titleText = computed(() => props.title || t(`${currentLanguage.value}.achivement.challenge.stop_machine_title`));
const messageText = computed(() => props.message || t(`${currentLanguage.value}.achivement.challenge.stop_machine_message`));
const finishText = computed(() => props.finishLabel || t(`${currentLanguage.value}.achivement.challenge.finish_machine`));
const continueText = computed(() => props.continueLabel || t(`${currentLanguage.value}.achivement.challenge.continue_using`));



const onFinish = () => {
	if (props.loading) {
		return;
	}

	emit('finish');
};

const onContinueUsing = () => {
	emit('continue-using');
};

const onOverlayClick = () => {
	if (!props.closeOnOverlay || props.loading) {
		return;
	}

	emit('close');
};

const onEscKey = (event: KeyboardEvent) => {
	if (event.key !== 'Escape' || !props.show || props.loading) {
		return;
	}

	emit('close');
};

onMounted(() => {
	window.addEventListener('keydown', onEscKey);
});

onBeforeUnmount(() => {
	window.removeEventListener('keydown', onEscKey);
});

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "finish-machine-overlay",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "finish-machine-title",
        onClick: _withModifiers(onOverlayClick, ["self"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(titleText)), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(messageText)), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              disabled: __props.loading,
              onClick: onContinueUsing
            }, _toDisplayString(_unref(continueText)), 9, _hoisted_6),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              disabled: __props.loading,
              onClick: onFinish
            }, [
              (__props.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_unref(finishText)), 1)
            ], 8, _hoisted_7)
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})